const { createElement, useState, useEffect } = React;
const { render } = ReactDOM;

const BookingComponent = () => {
  const container = document.getElementById('booking-component');
  const variants = JSON.parse(container.dataset.variants || '[]');
  const disabledDatesStr = container.dataset.disabledDates || '';
  const disableMondays = container.dataset.disableMondays === 'true';
  
  // Configuración del Ritual Patagónico
  const ritualConfig = {
    productId: '10254400291091',
    basePrice: 6000000, // $60.000 en centavos — precio base (tachado). El % de descuento se calcula desde aquí.
    price: 3000000, // $30.000 en centavos — precio por defecto si la fecha no tiene variante de temporada en Shopify
    minHour: 11,
    maxHour: 20,
    intervalMinutes: 30,
    maxSlots: 8,
    // URL de la API de disponibilidad (Google Apps Script)
    disponibilidadApiUrl: 'https://script.google.com/macros/s/AKfycbx0ELQbAOIGxS4zNFocj5JHFNodm19rXNjfF9YDTGoDFcw4oFSKMjKbvXcJyzP1luhv/exec'
  };

  // Configuración de temporadas - se carga desde Google Sheets
  // Tipos soportados: 'alta', 'baja', 'media', 'feriado', etc.
  // El sufijo en las variantes de Shopify debe coincidir (ej: "10:30 AV - Adulto")
  // Si no hay configuración o no coincide ningún rango, se usa 'alta verano' por defecto
  const defaultSeasonType = 'alta verano';
  
  // Mapeo de tipos de temporada a sufijos de variantes en Shopify
  // Los sufijos se usan para identificar variantes: "9:30 AV - Adulto"
  const seasonToVariantSuffix = {
    'alta verano': 'AV',      // Alta Verano
    'baja otoño': 'BO',       // Baja Otoño
    'alta invierno': 'AI',    // Alta Invierno
    'baja primavera': 'BP',   // Baja Primavera
    // Mantener compatibilidad con tipos antiguos
    'alta': 'AV',
    'media': 'BO',
    'baja': 'BP',
    'feriado': 'AV'           // Feriados usan precios de alta
  };
  
  // Mapeo de tipos de temporada a horarios disponibles (fallback si no hay en Excel)
  const seasonToTimeSlots = {
    'alta verano': ['9:30', '14:30', '18:30'],
    'baja otoño': ['10:30', '14:30'],
    'alta invierno': ['9:30', '14:30', '18:30'],
    'baja primavera': ['10:30', '14:30'],
    // Mantener compatibilidad con tipos antiguos
    'alta': ['9:30', '14:30', '18:30'],
    'media': ['9:30', '14:30', '18:30'],  // Agregado 9:30
    'feriado': ['9:30', '14:30', '18:30'],
    'baja': ['10:30', '14:30']
  };
  
  const translations = {
    'es': {
      hours: 'hrs.',
      hour: 'Horario de ingreso',
      date: 'Día',
      tickets: 'Nº de Entradas',
      adult: 'Adulto (desde los 13 años) ',
      adultShort: 'Adulto',
      adultDescription: '(desde los 13 años)',
      child: 'Niño (de 2 a 12 años) ',
      adult_singular: 'Adulto',
      adult_plural: 'Adultos',
      child_singular: 'Niño',
      child_plural: 'Niños',
      addToCart: 'Agregar al carro',
      addingToCart: 'Procesando...',
      total: 'Total',
      error: 'Por favor agregar todos los datos necesarios para la reserva.',
      errorNoTime: 'Por favor selecciona un horario de ingreso.',
      errorNoDate: 'Por favor selecciona una fecha.',
      loadingCalendar: 'Cargando calendario...',
      soldOut: 'Agotado',
      availableSpots: 'disponibles',
      errorNoTickets: 'Por favor selecciona al menos 1 entrada (adulto o niño).',
      errorNoRitualTime: 'Por favor selecciona un horario para el ritual o desactívalo.',
      errorRitualBeforeEntry: 'El horario del ritual debe ser posterior a tu hora de entrada a las Termas.',
      errorPastDateTime: 'La fecha y hora seleccionada ya pasó. Por favor elige una fecha u hora futura.',
      errorRitualSoldOut: 'Lo sentimos, el horario de ritual que seleccionaste se acaba de agotar. Por favor elige otro horario.',
      cartError: 'Error al agregar al carro',
      ritual: 'Ritual Patagónico',
      ritualOptional: 'Vive la experiencia completa #ritualpatagonico, agrégalo a tu entrada!',
      ritualDescription: '{discount}% off en la experiencia adicional de Ritual Patagónico.',
      addRitual: 'Agregar Ritual',
      ritualTime: 'Horario del Ritual',
      available: 'disponibles',
      soldOut: 'Agotado',
      checking: 'Verificando...',
      perPerson: 'por persona',
      selectTime: 'Seleccionar horario',
      noRitual: 'Sin ritual',
      ritualFor: 'Ritual para',
      discount: 'OFF',
      specialOffer: '¡Oferta especial!',
      noRitualSlots: 'No hay horarios de ritual disponibles para esta hora de entrada.'
    },
    'en': {
      hours: 'hrs.',
      hour: 'Admission time',
      date: 'Date',
      tickets: 'Number of Tickets',
      adult: 'Adult',
      adultShort: 'Adult',
      adultDescription: '(13 years and older)',
      child: 'Child',
      adult_singular: 'Adult',
      adult_plural: 'Adults',
      child_singular: 'Kid',
      child_plural: 'Kids',
      addToCart: 'Add to cart',
      addingToCart: 'Processing...',
      total: 'Total',
      error: 'Please add all required booking information.',
      errorNoTime: 'Please select an admission time.',
      errorNoDate: 'Please select a date.',
      loadingCalendar: 'Loading calendar...',
      soldOut: 'Sold out',
      availableSpots: 'available',
      errorNoTickets: 'Please select at least 1 ticket (adult or child).',
      errorNoRitualTime: 'Please select a time for the ritual or disable it.',
      errorRitualBeforeEntry: 'The ritual time must be after your Termas entry time.',
      errorPastDateTime: 'The selected date and time has already passed. Please choose a future date or time.',
      errorRitualSoldOut: 'Sorry, the ritual time you selected just sold out. Please choose another time.',
      cartError: 'Error adding to cart',
      ritual: 'Patagonian Ritual',
      ritualOptional: 'Live the full experience #PatagonianRitual',
      ritualDescription: '{discount}% off for the first ones to experience it.',
      addRitual: 'Add Ritual',
      ritualTime: 'Ritual Time',
      available: 'available',
      soldOut: 'Sold out',
      checking: 'Checking...',
      perPerson: 'per person',
      selectTime: 'Select time',
      noRitual: 'No ritual',
      ritualFor: 'Ritual for',
      discount: 'OFF',
      specialOffer: 'Special offer!',
      noRitualSlots: 'No ritual times available for this entry time.'
    },
    'pt-BR': {
      hours: 'hrs.',
      hour: 'Hora',
      date: 'Data',
      tickets: 'Número de Ingressos',
      adult: 'Adulto(a)',
      adultShort: 'Adulto(a)',
      adultDescription: '(a partir de 13 anos)',
      child: 'Criança',
      adult_singular: 'Adulto(a)',
      adult_plural: 'Adultos(as)',
      child_singular: 'Criança',
      child_plural: 'Crianças',
      addToCart: 'Adicionar ao carrinho',
      total: 'Total',
      error: 'Por favor, adicione todas as informações necessárias.',
      errorNoTime: 'Por favor, selecione um horário de entrada.',
      errorNoDate: 'Por favor, selecione uma data.',
      loadingCalendar: 'Carregando calendário...',
      soldOut: 'Esgotado',
      availableSpots: 'disponíveis',
      errorNoTickets: 'Por favor, selecione pelo menos 1 ingresso (adulto ou criança).',
      errorNoRitualTime: 'Por favor, selecione um horário para o ritual ou desative-o.',
      errorRitualBeforeEntry: 'O horário do ritual deve ser posterior ao horário de entrada nas Termas.',
      errorPastDateTime: 'A data e hora selecionadas já passaram. Por favor, escolha uma data ou hora futura.',
      errorRitualSoldOut: 'Desculpe, o horário do ritual que você selecionou esgotou. Por favor, escolha outro horário.',
      cartError: 'Erro ao adicionar ao carrinho',
      ritual: 'Ritual Patagônico',
      ritualOptional: 'Viva a experiência completa #RitualPatagônico',
      ritualDescription: '{discount}% off para os primeiros a vivê-lo.',
      addRitual: 'Adicionar Ritual',
      ritualTime: 'Horário do Ritual',
      available: 'disponíveis',
      soldOut: 'Esgotado',
      checking: 'Verificando...',
      perPerson: 'por pessoa',
      selectTime: 'Selecionar horário',
      noRitual: 'Sem ritual',
      ritualFor: 'Ritual para',
      discount: 'OFF',
      specialOffer: 'Oferta especial!',
      noRitualSlots: 'Não há horários de ritual disponíveis para este horário de entrada.'
    }
  };

  const currentLocale = window.Shopify?.locale || 'es';
  const t = translations[currentLocale] || translations['es'];
  
  // Estado para la configuración de temporadas cargada desde Google Sheets
  const [seasonConfig, setSeasonConfig] = useState([]);
  const [seasonConfigLoaded, setSeasonConfigLoaded] = useState(false);
  const [seasonConfigFailed, setSeasonConfigFailed] = useState(false);  // Fail-safe: no se pudo verificar temporadas
  const [blockedDates, setBlockedDates] = useState([]);  // Días bloqueados desde Excel
  
  // Cargar configuración de temporadas desde Google Sheets
  useEffect(() => {
    const fetchSeasonConfig = async () => {
      let okCfg = false;
      try {
        const response = await fetch(`${ritualConfig.disponibilidadApiUrl}?action=temporadas`);
        if (response.ok) {
          const data = await response.json();
          if (data.success && data.temporadas && data.temporadas.length > 0) {
            setSeasonConfig(data.temporadas);
            okCfg = true;
            console.log('Configuración de temporadas cargada:', data.temporadas);
          }
          // Cargar días bloqueados
          if (data.diasBloqueados && data.diasBloqueados.length > 0) {
            setBlockedDates(data.diasBloqueados);
            console.log('Días bloqueados cargados:', data.diasBloqueados);
          }
        }
      } catch (error) {
        console.warn('Error cargando configuración de temporadas:', error);
      } finally {
        // Fail-safe (2026-07-18): si NO se pudo cargar la configuración, NO
        // asumir "alta verano" (vendía 18:30 fuera de temporada, orden #37649).
        // Se bloquean los horarios y se pide recargar la página.
        if (!okCfg) setSeasonConfigFailed(true);
        setSeasonConfigLoaded(true);
      }
    };
    
    fetchSeasonConfig();
  }, []);
  
  // Función para obtener la configuración de temporada para una fecha
  // Retorna el objeto completo: { tipo, horarios } o null si no encuentra
  const getSeasonConfig = (date) => {
    if (!date) return null;
    
    // Formatear fecha como YYYY-MM-DD
    const dateStr = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    
    // Buscar en la configuración cargada desde Google Sheets
    for (const config of seasonConfig) {
      // Verificar si la fecha está en el rango
      if (dateStr >= config.fechaInicio && dateStr <= config.fechaFin) {
        return config;
      }
    }
    
    return null;
  };
  
  // Función para obtener el tipo de temporada de una fecha
  // Retorna: 'alta', 'baja', 'media', 'feriado', etc.
  const getSeasonType = (date) => {
    const config = getSeasonConfig(date);
    return config ? config.tipo.toLowerCase() : defaultSeasonType;
  };
  
  // Función para verificar si una fecha está bloqueada
  // Verifica tanto la hoja "Días Bloqueados" como el campo "bloqueado" en Temporadas
  // Retorna: { blocked: boolean, reason: string }
  const isDateBlocked = (date) => {
    if (!date) return { blocked: false, reason: '' };
    
    const dateStr = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    
    // Verificar en la hoja "Días Bloqueados" (si existe)
    if (blockedDates.length > 0) {
      const blockedEntry = blockedDates.find(d => d.fecha === dateStr);
      if (blockedEntry) {
        return { blocked: true, reason: blockedEntry.motivo || 'No disponible' };
      }
    }
    
    // Verificar si la temporada de esta fecha tiene bloqueado = true
    const config = getSeasonConfig(date);
    if (config && config.bloqueado === true) {
      return { blocked: true, reason: 'Período bloqueado' };
    }
    
    return { blocked: false, reason: '' };
  };
  
  // Función para obtener los horarios disponibles para ENTRADAS
  // Primero intenta usar los horarios del Excel, si no hay, usa los del código
  const getTimeSlotsForDate = (date) => {
    const config = getSeasonConfig(date);
    
    // Si hay configuración del Excel con horarios definidos, usarlos
    if (config && config.horarios && config.horarios.length > 0) {
      console.log('Usando horarios del Excel:', config.horarios);
      return config.horarios;
    }
    
    // Fail-safe (2026-07-18): sin configuración VERIFICADA de temporada no se
    // ofrecen horarios (antes caía a "alta verano" y vendía 18:30 en invierno).
    if (seasonConfigFailed || !config) {
      console.warn('Temporada no verificada para la fecha: sin horarios (fail-safe).');
      return [];
    }
    const seasonType = config.tipo.toLowerCase();
    const fallbackSlots = seasonToTimeSlots[seasonType] || [];
    console.log('Usando horarios del código (fallback):', fallbackSlots);
    return fallbackSlots;
  };
  
  // Función para obtener los horarios disponibles para RITUALES
  // Usa los horarios generados cada 30 min desde el Excel
  const getRitualTimeSlotsForDate = (date) => {
    const config = getSeasonConfig(date);
    
    // Si hay horarios de ritual definidos en el Excel, usarlos
    if (config && config.horariosRitual && config.horariosRitual.length > 0) {
      console.log('Usando horarios ritual del Excel:', config.horariosRitual);
      return config.horariosRitual;
    }
    
    // Fallback: generar horarios por defecto (11:00 a 20:00 cada 30 min)
    const defaultRitualSlots = [];
    for (let h = 11; h <= 20; h++) {
      defaultRitualSlots.push(`${h}:00`);
      if (h < 20) defaultRitualSlots.push(`${h}:30`);
    }
    console.log('Usando horarios ritual por defecto:', defaultRitualSlots);
    return defaultRitualSlots;
  };
  
  // Función para obtener el precio del ritual para una fecha
  const getRitualPriceForDate = (date) => {
    const config = getSeasonConfig(date);
    
    if (config && config.precioRitual !== null && config.precioRitual !== undefined) {
      console.log('Precio ritual del Excel:', config.precioRitual);
      return config.precioRitual;
    }
    
    // Fallback: retornar null (usar precio de Shopify)
    return null;
  };
  
  // Función para obtener info del ritual (primer y último ingreso)
  const getRitualInfoForDate = (date) => {
    const config = getSeasonConfig(date);
    
    if (config) {
      return {
        primerIngreso: config.ritualPrimerIngreso || null,
        ultimoIngreso: config.ritualUltimoIngreso || null,
        precio: config.precioRitual || null
      };
    }
    
    return { primerIngreso: null, ultimoIngreso: null, precio: null };
  };

  // Busca la variante de Ritual correspondiente a la temporada (precio por temporada).
  // Las variantes nuevas deben tener el código de temporada en su título: AV / BO / AI / BP
  // (ej: "Alta Verano (AV)"). Devuelve { id, price } o null si todavía no existen
  // variantes por temporada (en ese caso el widget mantiene el comportamiento anterior).
  const findRitualSeasonVariant = (variantsArr, seasonType) => {
    const suffix = (seasonToVariantSuffix[seasonType] || '').toUpperCase();
    if (!suffix || !Array.isArray(variantsArr)) return null;
    // El código debe aparecer como token delimitado (no dentro de otra palabra).
    const tokenRe = new RegExp('(^|[^A-Za-z])' + suffix + '([^A-Za-z]|$)');
    const v = variantsArr.find(rv => {
      const t = String(rv.title || '').toUpperCase();
      return t === suffix || tokenRe.test(t);
    });
    return v ? { id: v.id, price: Number(v.price) } : null;
  };

  // Mantener compatibilidad con código existente que usa isHighSeason
  const isHighSeason = (date) => {
    const seasonType = getSeasonType(date);
    return seasonType === 'alta' || seasonType === 'feriado';
  };

  const typeMap = {
    'Adulto': 'adult',
    'Adult': 'adult',
    'Adulto(a)': 'adult',
    'Adultos': 'adult',
    'Niño': 'child',
    'Niña': 'child',
    'Child': 'child',
    'Children': 'child',
    'Criança': 'child',
    'Crianças': 'child',
    'Criancas': 'child',
    'Infantil': 'child'
  };

  const normalizeTime = (timeStr) => {
    return timeStr
      .replace(/\s*(AM|PM|am|pm)\s*/g, '')
      .replace(/h/g, ':')
      .trim();
  };

  // Detectar el sufijo de temporada en el título de la variante
  const detectSeasonSuffix = (title) => {
    // Buscar sufijos conocidos en el título
    for (const [seasonType, suffix] of Object.entries(seasonToVariantSuffix)) {
      if (suffix && title.includes(` ${suffix} `)) {
        return { suffix, seasonType };
      }
    }
    return { suffix: '', seasonType: 'baja' };
  };
  
  const variantsByTime = variants.reduce((acc, variant) => {
    console.log('Processing variant:', variant.title);
    
    const { suffix, seasonType } = detectSeasonSuffix(variant.title);
    const parts = variant.title.split(/\s*[-–—]\s*/);
    if (parts.length < 2) return acc;

    const timeSegment = parts[0].trim();
    // Remover cualquier sufijo de temporada del segmento de hora
    let time = timeSegment;
    for (const s of Object.values(seasonToVariantSuffix)) {
      if (s) time = time.replace(` ${s}`, '');
    }
    time = normalizeTime(time);
    
    const type = parts[parts.length - 1].trim();
    const variantKey = suffix ? `${time}_${suffix}` : time;
    
    if (!acc[variantKey]) acc[variantKey] = {};
    
    const typeKey = typeMap[type] || (type.toLowerCase().includes('adult') ? 'adult' : 'child');
    acc[variantKey][typeKey] = {
      id: variant.id,
      price: variant.price,
      seasonType: seasonType
    };

    console.log('Added variant:', {variantKey, typeKey, price: variant.price, seasonType});
    return acc;
  }, {});

  console.log('Final variants:', variantsByTime);

  const disabledDates = disabledDatesStr.split(',').map((d) => d.trim());

  // Generar ID de sesión único para reservas temporales
  const generateSessionId = () => {
    return 'sess_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  };
  
  // Obtener o crear sessionId (persistir en sessionStorage)
  const getSessionId = () => {
    let sessionId = sessionStorage.getItem('ritual_session_id');
    if (!sessionId) {
      sessionId = generateSessionId();
      sessionStorage.setItem('ritual_session_id', sessionId);
    }
    return sessionId;
  };

  // Estados principales
  const [selectedTime, setSelectedTime] = useState('');
  const [selectedDate, setSelectedDate] = useState(null);
  const [adults, setAdults] = useState(1);
  const [children, setChildren] = useState(0);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [openSections, setOpenSections] = useState(['date', 'ritual']);
  const [sessionId] = useState(getSessionId);
  
  // Estados para Ritual Patagónico - ahora es un array para cada adulto
  // Formato: [{ enabled: boolean, time: string }, ...]
  const [adultRituals, setAdultRituals] = useState([{ enabled: false, time: '' }]);
  const [ritualVariants, setRitualVariants] = useState([]);
  const [ritualAvailability, setRitualAvailability] = useState({});
  const [loadingRitual, setLoadingRitual] = useState(false);
  const [isAddingToCart, setIsAddingToCart] = useState(false);
  
  // Estados para disponibilidad de entradas
  const [entradasDisponibilidad, setEntradasDisponibilidad] = useState({});
  const [loadingEntradas, setLoadingEntradas] = useState(false);

  // Obtener horarios según la fecha seleccionada (del Excel o fallback al código)
  const currentSeasonType = getSeasonType(selectedDate);
  const timeSlots = getTimeSlotsForDate(selectedDate);

  const sections = ['date', 'time', 'tickets', 'ritual'];
  const weekDays = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];

  const formatDate = (isoDate) => new Date(isoDate).toLocaleDateString('es-ES');

  // Actualizar array de rituales cuando cambia el número de adultos
  useEffect(() => {
    setAdultRituals(prev => {
      if (adults > prev.length) {
        // Agregar más slots
        const newSlots = Array(adults - prev.length).fill(null).map(() => ({ enabled: false, time: '' }));
        return [...prev, ...newSlots];
      } else if (adults < prev.length) {
        // Reducir slots
        return prev.slice(0, adults);
      }
      return prev;
    });
  }, [adults]);

  // Resetear rituales cuando cambia la hora principal
  useEffect(() => {
    setAdultRituals(prev => prev.map(() => ({ enabled: false, time: '' })));
  }, [selectedTime]);

  // Función para consultar disponibilidad de entradas para una fecha
  const fetchEntradasDisponibilidad = async (fecha) => {
    if (!fecha) return;
    
    setLoadingEntradas(true);
    try {
      // Formatear fecha como YYYY-MM-DD
      const fechaStr = `${fecha.getFullYear()}-${String(fecha.getMonth() + 1).padStart(2, '0')}-${String(fecha.getDate()).padStart(2, '0')}`;
      
      const response = await fetch(`${ritualConfig.disponibilidadApiUrl}?action=disponibilidad-entradas&fecha=${fechaStr}`);
      const data = await response.json();
      
      if (data.success) {
        console.log('Disponibilidad de entradas:', data);
        setEntradasDisponibilidad(data);
      }
    } catch (error) {
      console.warn('Error consultando disponibilidad de entradas:', error);
      setEntradasDisponibilidad({});
    } finally {
      setLoadingEntradas(false);
    }
  };
  
  // Consultar disponibilidad cuando cambia la fecha seleccionada
  useEffect(() => {
    if (selectedDate) {
      fetchEntradasDisponibilidad(selectedDate);
    }
  }, [selectedDate]);
  
  // Función para verificar si un horario está agotado
  const isTimeSlotSoldOut = (time) => {
    if (!entradasDisponibilidad || entradasDisponibilidad.sinLimite) return false;
    const disp = entradasDisponibilidad.disponibilidad?.[time];
    return disp?.agotado === true;
  };
  
  // Función para obtener disponibilidad de un horario
  const getTimeSlotAvailability = (time) => {
    if (!entradasDisponibilidad || entradasDisponibilidad.sinLimite) return null;
    return entradasDisponibilidad.disponibilidad?.[time] || null;
  };

  // Generar horarios disponibles para el ritual
  // Primero intenta usar los horarios del Excel, si no, genera basado en hora de entrada
  const generateRitualTimeSlots = () => {
    if (!selectedTime) return [];
    
    // PRIMERO: Intentar usar horarios del Excel
    const excelRitualSlots = getRitualTimeSlotsForDate(selectedDate);
    if (excelRitualSlots && excelRitualSlots.length > 0) {
      // Filtrar solo horarios que sean posteriores a la hora de entrada + 30 min
      const [entryHour, entryMin] = selectedTime.split(':').map(Number);
      const entryMinutes = entryHour * 60 + entryMin + 30; // +30 min mínimo
      
      const filteredSlots = excelRitualSlots.filter(slot => {
        const [h, m] = slot.split(':').map(Number);
        const slotMinutes = h * 60 + (m || 0);
        return slotMinutes >= entryMinutes;
      });

      // Respetar SIEMPRE el tope del Excel: si la hora de entrada es igual o
      // posterior al último ingreso del ritual, no hay rituales disponibles.
      // Retornamos la lista filtrada aunque quede vacía y NO caemos al fallback,
      // para no inventar horarios más tarde que el último ingreso configurado.
      console.log('Usando horarios ritual del Excel (filtrados):', filteredSlots);
      return filteredSlots;
    }
    
    // FALLBACK: Generar horarios basados en hora de entrada
    const [hours, minutes] = selectedTime.split(':').map(Number);
    const slots = [];
    
    // Restricciones especiales por fecha
    const blockedDates = {
      '2026-01-12': 13  // Lunes 12 de enero: bloquear antes de las 13:00
    };
    
    // Verificar si la fecha tiene restricción especial
    let minHourForDate = ritualConfig.minHour;
    if (selectedDate) {
      const dateKey = `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}-${String(selectedDate.getDate()).padStart(2, '0')}`;
      if (blockedDates[dateKey]) {
        minHourForDate = blockedDates[dateKey];
      }
    }
    
    let currentHour = hours;
    let currentMinutes = minutes + 30;
    
    if (currentMinutes >= 60) {
      currentHour += 1;
      currentMinutes -= 60;
    }
    
    // Usar la hora mínima considerando restricciones
    if (currentHour < minHourForDate) {
      currentHour = minHourForDate;
      currentMinutes = 0;
    }
    
    while (currentHour < ritualConfig.maxHour || (currentHour === ritualConfig.maxHour && currentMinutes === 0)) {
      const timeStr = `${currentHour.toString().padStart(2, '0')}:${currentMinutes.toString().padStart(2, '0')}`;
      slots.push(timeStr);
      
      currentMinutes += 30;
      if (currentMinutes >= 60) {
        currentHour += 1;
        currentMinutes = 0;
      }
    }
    
    return slots;
  };

  // Calcular cuántos rituales hay seleccionados por cada horario
  const getRitualCountByTime = () => {
    const counts = {};
    adultRituals.forEach(ritual => {
      if (ritual.enabled && ritual.time) {
        counts[ritual.time] = (counts[ritual.time] || 0) + 1;
      }
    });
    return counts;
  };

  // Verificar disponibilidad real considerando selecciones actuales
  const getAvailableForTime = (time, excludeAdultIndex = -1) => {
    const baseAvailable = ritualAvailability[time]?.inventory ?? ritualConfig.maxSlots;
    const ritualCounts = getRitualCountByTime();
    
    // Contar cuántos ya están seleccionados para este horario (excluyendo el adulto actual si aplica)
    let currentlySelected = 0;
    adultRituals.forEach((ritual, index) => {
      if (ritual.enabled && ritual.time === time && index !== excludeAdultIndex) {
        currentlySelected++;
      }
    });
    
    return baseAvailable - currentlySelected;
  };

  // Cargar variantes del producto Ritual Patagónico
  // Ahora filtra por temporada usando el sufijo (HS, MS, etc.)
  const fetchRitualVariants = async () => {
    try {
      setLoadingRitual(true);
      const response = await fetch(`/products/ritual-patagonico.js`);
      if (response.ok) {
        const product = await response.json();
        setRitualVariants(product.variants || []);
        
        // Obtener el sufijo de temporada para la fecha seleccionada
        const seasonType = selectedDate ? getSeasonType(selectedDate) : defaultSeasonType;
        const suffix = seasonToVariantSuffix[seasonType] || '';
        
        console.log('Buscando variantes de Ritual para temporada:', seasonType, '| Sufijo:', suffix || '(sin sufijo)');
        
        const availability = {};
        product.variants.forEach(variant => {
          const timeMatch = variant.title.match(/(\d{1,2}:\d{2})/);
          if (timeMatch) {
            const time = timeMatch[1];
            const normalizedTime = time.length === 4 ? '0' + time : time;
            const titleLower = variant.title.toLowerCase();
            
            // Determinar el sufijo de la variante
            const { suffix: variantSuffix } = detectSeasonSuffix(variant.title);
            
            // Solo incluir si coincide con la temporada actual
            // Si buscamos HS, solo variantes con HS
            // Si buscamos sin sufijo (baja), solo variantes sin sufijo
            const matchesSeason = (suffix === '' && variantSuffix === '') || 
                                  (suffix !== '' && variantSuffix.toUpperCase() === suffix.toUpperCase());
            
            if (matchesSeason) {
              availability[normalizedTime] = {
                id: variant.id,
                available: variant.available,
                inventory: variant.inventory_quantity || ritualConfig.maxSlots,
                price: variant.price,
                seasonType: seasonType
              };
            }
          }
        });
        
        // Si no encontramos variantes para la temporada, intentar sin sufijo (fallback)
        if (Object.keys(availability).length === 0) {
          console.log('No se encontraron variantes de ritual para', suffix, '- usando fallback sin sufijo');
          product.variants.forEach(variant => {
            const timeMatch = variant.title.match(/(\d{1,2}:\d{2})/);
            if (timeMatch) {
              const time = timeMatch[1];
              const normalizedTime = time.length === 4 ? '0' + time : time;
              const { suffix: variantSuffix } = detectSeasonSuffix(variant.title);
              
              // Solo tomar variantes sin sufijo de temporada
              if (variantSuffix === '') {
                availability[normalizedTime] = {
                  id: variant.id,
                  available: variant.available,
                  inventory: variant.inventory_quantity || ritualConfig.maxSlots,
                  price: variant.price,
                  seasonType: 'default'
                };
              }
            }
          });
        }
        
        // Con variantes por temporada (sin hora en el título) esta disponibilidad
        // por hora queda vacía; en ese caso NO sobreescribimos la que trae el
        // Google Sheet (checkRitualAvailability), que es la fuente real de cupos.
        if (Object.keys(availability).length > 0) {
          setRitualAvailability(availability);
          console.log('Ritual availability (temporada ' + seasonType + '):', availability);
        }
      }
    } catch (error) {
      console.error('Error fetching ritual variants:', error);
    } finally {
      setLoadingRitual(false);
    }
  };

  // Verificar disponibilidad en tiempo real desde Google Sheets API
  // Ahora considera la temporada para buscar la variante correcta
  const checkRitualAvailability = async () => {
    if (!selectedDate) return;
    
    try {
      setLoadingRitual(true);
      
      // Formatear fecha como YYYY-MM-DD
      const fechaFormateada = `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}-${String(selectedDate.getDate()).padStart(2, '0')}`;
      
      // Obtener el sufijo de temporada para la fecha
      const seasonType = getSeasonType(selectedDate);
      const suffix = seasonToVariantSuffix[seasonType] || '';
      
      console.log('Verificando disponibilidad ritual para temporada:', seasonType, '| Sufijo:', suffix || '(sin sufijo)');
      
      // Intentar consultar la API de Google Sheets primero
      if (ritualConfig.disponibilidadApiUrl && ritualConfig.disponibilidadApiUrl !== 'TU_URL_DE_GOOGLE_APPS_SCRIPT_AQUI') {
        try {
          const apiResponse = await fetch(`${ritualConfig.disponibilidadApiUrl}?fecha=${fechaFormateada}`);
          if (apiResponse.ok) {
            const data = await apiResponse.json();
            if (data.success && data.disponibilidad) {
              // Combinar con los IDs de variantes de Shopify
              const productResponse = await fetch(`/products/ritual-patagonico.js`);
              const product = productResponse.ok ? await productResponse.json() : { variants: [] };
              
              const availability = {};
              Object.entries(data.disponibilidad).forEach(([hora, info]) => {
                // Buscar el ID de la variante correspondiente CON SUFIJO DE TEMPORADA
                let variant = product.variants?.find(v => {
                  const timeMatch = v.title.match(/(\d{1,2}:\d{2})/);
                  if (timeMatch) {
                    let variantTime = timeMatch[1];
                    if (variantTime.length === 4) variantTime = '0' + variantTime;
                    const { suffix: variantSuffix } = detectSeasonSuffix(v.title);
                    
                    // Coincidir hora Y sufijo de temporada
                    const timeMatches = variantTime === hora;
                    const seasonMatches = (suffix === '' && variantSuffix === '') || 
                                         (suffix !== '' && variantSuffix.toUpperCase() === suffix.toUpperCase());
                    
                    return timeMatches && seasonMatches;
                  }
                  return false;
                });
                
                // Fallback: si no encuentra con sufijo, buscar sin sufijo
                if (!variant) {
                  variant = product.variants?.find(v => {
                    const timeMatch = v.title.match(/(\d{1,2}:\d{2})/);
                    if (timeMatch) {
                      let variantTime = timeMatch[1];
                      if (variantTime.length === 4) variantTime = '0' + variantTime;
                      const { suffix: variantSuffix } = detectSeasonSuffix(v.title);
                      return variantTime === hora && variantSuffix === '';
                    }
                    return false;
                  });
                }
                
                availability[hora] = {
                  id: variant?.id,
                  available: info.disponibles > 0,
                  inventory: info.disponibles,
                  price: variant?.price || ritualConfig.price,
                  maximos: info.maximos,
                  reservados: info.reservados,
                  seasonType: seasonType
                };
              });
              
              setRitualAvailability(availability);
              console.log('Disponibilidad desde API (fecha:', fechaFormateada, ', temporada:', seasonType, '):', availability);
              return;
            }
          }
        } catch (apiError) {
          console.warn('API de disponibilidad no disponible, usando fallback:', apiError);
        }
      }
      
      // Fallback: usar el método anterior (inventario global de Shopify)
      const response = await fetch(`/products/ritual-patagonico.js?v=${Date.now()}`);
      if (response.ok) {
        const product = await response.json();
        const availability = {};
        
        product.variants.forEach(variant => {
          const timeMatch = variant.title.match(/(\d{1,2}:\d{2})/);
          if (timeMatch) {
            let time = timeMatch[1];
            if (time.length === 4) time = '0' + time;
            
            availability[time] = {
              id: variant.id,
              available: variant.available,
              inventory: variant.inventory_quantity !== undefined ? variant.inventory_quantity : ritualConfig.maxSlots,
              price: variant.price
            };
          }
        });
        
        setRitualAvailability(availability);
        console.log('Disponibilidad desde Shopify (fallback):', availability);
      }
    } catch (error) {
      console.error('Error checking ritual availability:', error);
    } finally {
      setLoadingRitual(false);
    }
  };

  // Cargar variantes de ritual al inicio
  useEffect(() => {
    fetchRitualVariants();
  }, []);
  
  // Recargar variantes cuando cambie la fecha (para obtener las de la temporada correcta)
  useEffect(() => {
    if (selectedDate) {
      fetchRitualVariants();
    }
  }, [selectedDate]);

  useEffect(() => {
    if (selectedDate && adults > 0) {
      checkRitualAvailability();
    }
  }, [selectedDate]);

  const getCurrentPrices = () => {
    if (!selectedTime || !selectedDate) {
      return {
        adultPrice: 0,
        childPrice: 0,
        adultVariantId: null,
        childVariantId: null,
        seasonType: defaultSeasonType
      };
    }
    
    const seasonType = getSeasonType(selectedDate);
    const suffix = seasonToVariantSuffix[seasonType] || '';
    const normalizedTime = normalizeTime(selectedTime);
    const variantKey = suffix ? `${normalizedTime}_${suffix}` : normalizedTime;
    
    console.log('Getting prices for:', { seasonType, suffix, variantKey });
    
    let variants = variantsByTime[variantKey];
    
    // Fallback: si no hay variante para esta temporada, buscar la de temporada baja
    if (!variants && suffix) {
      console.log('Variante de temporada no encontrada, usando fallback a temporada baja');
      variants = variantsByTime[normalizedTime];
    }
    
    if (!variants) {
      return {
        adultPrice: 0,
        childPrice: 0,
        adultVariantId: null,
        childVariantId: null,
        seasonType: seasonType
      };
    }
    
    return {
      adultPrice: variants?.adult?.price || 0,
      childPrice: variants?.child?.price || 0,
      adultVariantId: variants?.adult?.id,
      childVariantId: variants?.child?.id,
      seasonType: seasonType
    };
  };

  const { adultPrice, childPrice, adultVariantId, childVariantId, seasonType } = getCurrentPrices();

  // Contar cuántos rituales están habilitados
  const enabledRitualsCount = adultRituals.filter(r => r.enabled && r.time).length;

  // Precio del ritual según la temporada de la fecha seleccionada.
  // Si existe una variante por temporada en Shopify, su precio manda; si no,
  // se usa el precio por defecto de ritualConfig (comportamiento anterior).
  const ritualSeasonVariant = selectedDate
    ? findRitualSeasonVariant(ritualVariants, getSeasonType(selectedDate))
    : null;
  const ritualUnitPrice = ritualSeasonVariant ? ritualSeasonVariant.price : ritualConfig.price;
  // Precio base fijo (tachado) y % de descuento CALCULADO desde el precio de la temporada.
  // Ej: base $62.000 y temporada $30.000 → 52% OFF. Cada temporada muestra su propio %.
  const ritualOriginalPrice = ritualConfig.basePrice;
  const ritualDiscountPercent = ritualOriginalPrice > 0
    ? Math.max(0, Math.round((1 - ritualUnitPrice / ritualOriginalPrice) * 100))
    : 0;

  // Calcular total del ritual
  const calculateRitualTotal = () => {
    let total = 0;
    adultRituals.forEach(ritual => {
      if (ritual.enabled && ritual.time) {
        total += ritualUnitPrice;
      }
    });
    return total;
  };

  const isSectionVisible = (section) => {
    if (section === 'date') return true;
    if (section === 'time') return selectedDate !== null;
    if (section === 'tickets') return selectedDate !== null && selectedTime !== '';
    if (section === 'ritual') return selectedDate !== null && selectedTime !== '' && adults > 0;
    return false;
  };

  const toggleSection = (section) => {
    if (isSectionVisible(section)) {
      setOpenSections((prev) =>
        prev.includes(section) ? prev.filter((s) => s !== section) : [...prev, section]
      );
    }
  };

  const isDateDisabled = (date) => {
    const now = new Date();
    now.setHours(0, 0, 0, 0);

    if (date < now) return true;
    if (disableMondays && date.getDay() === 1) return true;

    const dateStr = date.toISOString().split('T')[0];
    if (disabledDates.includes(dateStr)) return true;
    
    // Verificar si está bloqueado desde el Excel
    const blockInfo = isDateBlocked(date);
    if (blockInfo.blocked) return true;
    
    return false;
  };

  const generateCalendarDays = () => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const days = [];

    let firstDayIndex = firstDay.getDay();
    firstDayIndex = firstDayIndex === 0 ? 6 : firstDayIndex - 1;

    for (let i = 0; i < firstDayIndex; i++) {
      const prevDate = new Date(firstDay);
      prevDate.setDate(prevDate.getDate() - (firstDayIndex - i));
      days.push({
        day: prevDate.getDate(),
        month: 'prev',
        date: prevDate,
        disabled: isDateDisabled(prevDate)
      });
    }

    for (let i = 1; i <= lastDay.getDate(); i++) {
      const currentDate = new Date(year, month, i);
      days.push({
        day: i,
        month: 'current',
        date: currentDate,
        disabled: isDateDisabled(currentDate),
      });
    }

    const totalDays = days.length;
    for (let i = 1; totalDays + i <= 42; i++) {
      const nextDate = new Date(lastDay);
      nextDate.setDate(nextDate.getDate() + i);
      days.push({
        day: nextDate.getDate(),
        month: 'next',
        date: nextDate,
        disabled: isDateDisabled(nextDate)
      });
    }

    return days;
  };

  const formatMonth = (date) =>
    date.toLocaleString('es-ES', { month: 'long', year: 'numeric' });

  const nextMonth = () => setCurrentMonth((prev) => new Date(prev.setMonth(prev.getMonth() + 1)));
  const prevMonth = () => setCurrentMonth((prev) => new Date(prev.setMonth(prev.getMonth() - 1)));

  const handleTimeSelection = (time) => {
    setSelectedTime(time);
    setOpenSections((prev) => [...new Set([...prev, 'time', 'tickets'])]);
  };

  const handleDateSelection = (date) => {
    setSelectedDate(date);
    // Fix (2026-07-18): al cambiar la fecha, el horario elegido NO debe quedar
    // "pegado" si la nueva fecha no lo ofrece (permitía elegir 18:30 en una
    // fecha de verano, volver a una fecha de invierno y comprar 18:30 con los
    // valores antiguos).
    if (selectedTime && !getTimeSlotsForDate(date).includes(selectedTime)) {
      setSelectedTime('');
    }
    setOpenSections((prev) => [...new Set([...prev, 'date', 'time'])]);
  };

  // Toggle ritual para un adulto específico
  const handleRitualToggle = (adultIndex) => {
    setAdultRituals(prev => {
      const updated = [...prev];
      updated[adultIndex] = {
        ...updated[adultIndex],
        enabled: !updated[adultIndex].enabled,
        time: !updated[adultIndex].enabled ? '' : updated[adultIndex].time
      };
      return updated;
    });
  };

  // Seleccionar horario de ritual para un adulto específico
  const handleRitualTimeSelection = (adultIndex, time) => {
    setAdultRituals(prev => {
      const updated = [...prev];
      updated[adultIndex] = {
        ...updated[adultIndex],
        time: time
      };
      return updated;
    });
  };

  // Calcular total general
  const calculateTotal = () => {
    const ticketsTotal = (adults * adultPrice) + (children * childPrice);
    const ritualTotal = calculateRitualTotal();
    return ticketsTotal + ritualTotal;
  };

  const addToCart = async () => {
    // Validaciones con mensajes específicos
    if (!selectedTime) {
      alert(t.errorNoTime);
      return;
    }

    // Defensa (2026-07-18): el horario elegido debe existir para la FECHA
    // elegida (evita comprar un horario de otra temporada si quedó pegado).
    if (selectedDate && !getTimeSlotsForDate(selectedDate).includes(selectedTime)) {
      setSelectedTime('');
      alert(t.errorNoTime);
      return;
    }
    
    if (!selectedDate) {
      alert(t.errorNoDate);
      return;
    }
    
    if (adults === 0 && children === 0) {
      alert(t.errorNoTickets);
      return;
    }

    // Validar que los rituales habilitados tengan horario seleccionado
    const invalidRituals = adultRituals.some(r => r.enabled && !r.time);
    if (invalidRituals) {
      alert(t.errorNoRitualTime);
      return;
    }

    // Validar que los rituales sean POSTERIORES a la hora de entrada
    const [entryHour, entryMin] = selectedTime.split(':').map(Number);
    const entryMinutes = entryHour * 60 + (entryMin || 0);
    
    const invalidRitualTimes = adultRituals.some(r => {
      if (!r.enabled || !r.time) return false;
      const [ritualHour, ritualMin] = r.time.split(':').map(Number);
      const ritualMinutes = ritualHour * 60 + (ritualMin || 0);
      // El ritual debe ser al menos 30 minutos después de la entrada
      return ritualMinutes < entryMinutes + 30;
    });
    
    if (invalidRitualTimes) {
      alert(t.errorRitualBeforeEntry);
      return;
    }

    // Validar que la fecha y hora seleccionada no haya pasado
    const now = new Date();
    const [selectedHour, selectedMinute] = selectedTime.split(':').map(Number);
    const selectedDateTime = new Date(selectedDate);
    selectedDateTime.setHours(selectedHour, selectedMinute || 0, 0, 0);
    
    if (selectedDateTime < now) {
      alert(t.errorPastDateTime);
      return;
    }

    // Activar indicador de carga
    setIsAddingToCart(true);

    // Validar disponibilidad de rituales en tiempo real antes de agregar al carrito
    const ritualesSeleccionados = adultRituals.filter(r => r.enabled && r.time);
    const fechaFormateada = `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}-${String(selectedDate.getDate()).padStart(2, '0')}`;
    
    if (ritualesSeleccionados.length > 0 && ritualConfig.disponibilidadApiUrl && ritualConfig.disponibilidadApiUrl !== 'TU_URL_DE_GOOGLE_APPS_SCRIPT_AQUI') {
      try {
        const apiResponse = await fetch(`${ritualConfig.disponibilidadApiUrl}?fecha=${fechaFormateada}`);
        
        if (apiResponse.ok) {
          const data = await apiResponse.json();
          if (data.success && data.disponibilidad) {
            // Contar cuántos rituales se quieren por cada horario
            const conteoDeseado = {};
            ritualesSeleccionados.forEach(r => {
              conteoDeseado[r.time] = (conteoDeseado[r.time] || 0) + 1;
            });
            
            // Verificar disponibilidad para cada horario
            for (const [hora, cantidad] of Object.entries(conteoDeseado)) {
              const disponibles = data.disponibilidad[hora]?.disponibles || 0;
              if (cantidad > disponibles) {
                alert(t.errorRitualSoldOut);
                // Recargar disponibilidad
                await checkRitualAvailability();
                setIsAddingToCart(false);
                return;
              }
            }
            
            // Registrar reservas temporales para cada horario seleccionado
            for (const [hora, cantidad] of Object.entries(conteoDeseado)) {
              try {
                const reservaUrl = `${ritualConfig.disponibilidadApiUrl}?action=reservar&sessionId=${sessionId}&fecha=${fechaFormateada}&hora=${hora}&cantidad=${cantidad}`;
                await fetch(reservaUrl);
                console.log(`Reserva temporal registrada: ${hora} x${cantidad}`);
              } catch (reservaError) {
                console.warn('Error registrando reserva temporal:', reservaError);
              }
            }
          }
        }
      } catch (apiError) {
        console.warn('No se pudo verificar disponibilidad, continuando...', apiError);
      }
    }

    try {
      const items = [];
      
      // Generar fecha en formato YYYY-MM-DD usando hora LOCAL (no UTC)
      const bookingDateLocal = `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}-${String(selectedDate.getDate()).padStart(2, '0')}`;
      
      // Agregar entradas de adultos
      if (adults > 0) {
        items.push({
          id: adultVariantId,
          quantity: adults,
          properties: {
            Hora: selectedTime,
            Fecha: formatDate(selectedDate),
            _booking_date: bookingDateLocal
          },
        });
      }
      
      // Agregar entradas de niños
      if (children > 0) {
        items.push({
          id: childVariantId,
          quantity: children,
          properties: {
            Hora: selectedTime,
            Fecha: formatDate(selectedDate),
            _booking_date: bookingDateLocal
          },
        });
      }

      // Agregar rituales - agrupar por horario para optimizar
      const ritualsByTime = {};
      adultRituals.forEach((ritual, index) => {
        if (ritual.enabled && ritual.time) {
          if (!ritualsByTime[ritual.time]) {
            ritualsByTime[ritual.time] = {
              count: 0,
              // Precio por temporada: usar la variante de la temporada si existe;
              // si no, mantener la variante por horario (comportamiento anterior).
              variantId: ritualSeasonVariant?.id || ritualAvailability[ritual.time]?.id
            };
          }
          ritualsByTime[ritual.time].count++;
        }
      });

      // Agregar cada grupo de rituales al carrito
      Object.entries(ritualsByTime).forEach(([time, data]) => {
        if (data.variantId) {
          items.push({
            id: data.variantId,
            quantity: data.count,
            properties: {
              'Hora Ritual': time,
              'Hora Entrada': selectedTime,
              Fecha: formatDate(selectedDate),
              _booking_date: bookingDateLocal,
              _session_id: sessionId // Para limpiar reserva temporal al confirmar
            },
          });
        }
      });

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) {
        // Intentar obtener el mensaje de error de Shopify
        try {
          const errorData = await response.json();
          const errorMessage = errorData.description || errorData.message || t.cartError;
          console.error('Shopify error:', errorData);
          alert(`${t.cartError}: ${errorMessage}`);
          
          // Recargar disponibilidad de rituales después del error
          await checkRitualAvailability();
        } catch {
          alert(t.cartError);
        }
        setIsAddingToCart(false);
        return;
      }
      
      let currentLocale = window.Shopify?.locale;
      if (currentLocale) {
        currentLocale = currentLocale.split('-')[0];
      }

      if (currentLocale && currentLocale !== 'es') {
        window.location.href = `/${currentLocale}/cart`;
      } else {
        window.location.href = '/cart';
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert(t.cartError);
      setIsAddingToCart(false);
    }
  };

  // Sección de horarios
  // Fail-safe (2026-07-18): si no se pudo verificar la temporada (o la fecha no
  // tiene horarios configurados), avisar y pedir recargar la página en vez de
  // ofrecer horarios de una temporada equivocada.
  const seasonUnverified = seasonConfigFailed ||
    (seasonConfigLoaded && selectedDate && !loadingEntradas && timeSlots.length === 0);
  const timeSection = seasonUnverified
    ? createElement(
        'div',
        { className: 'time-slots-error', style: { padding: '14px', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '10px', color: '#991b1b', fontSize: '14px', lineHeight: '1.5' } },
        createElement('div', { style: { fontWeight: 600, marginBottom: '6px' } }, '⚠️ No pudimos verificar la disponibilidad de horarios.'),
        createElement('div', { style: { marginBottom: '10px' } }, 'Por favor recarga la página para intentarlo nuevamente.'),
        createElement(
          'button',
          { type: 'button', onClick: () => window.location.reload(), style: { background: '#dc2626', color: '#fff', border: 'none', borderRadius: '8px', padding: '9px 16px', fontWeight: 600, cursor: 'pointer' } },
          'Recargar página'
        )
      )
    : loadingEntradas && selectedDate
    ? createElement(
        'div',
        { className: 'time-slots-loading' },
        createElement('div', { className: 'loading-spinner small' }),
        createElement('span', null, 'Verificando disponibilidad...')
      )
    : createElement(
        'div',
        null,
        timeSlots.map((time) => {
          const isSoldOut = isTimeSlotSoldOut(time);
          const availability = getTimeSlotAvailability(time);
          
          return createElement(
            'div',
            {
              className: `time-slot ${selectedTime === time ? 'selected' : ''} ${isSoldOut ? 'sold-out' : ''}`,
              onClick: () => !isSoldOut && handleTimeSelection(time),
              key: time,
            },
            createElement('span', { className: 'time-value' }, `${time} ${t.hours}`),
            isSoldOut 
              ? createElement('span', { className: 'sold-out-badge' }, t.soldOut)
              : null
          );
        })
      );

  // Sección de calendario
  const dateSection = !seasonConfigLoaded 
    ? createElement(
        'div',
        { className: 'calendar-loading' },
        createElement('div', { className: 'loading-spinner' }),
        createElement('span', null, t.loadingCalendar)
      )
    : createElement(
        'div',
        null,
        createElement(
          'div',
          { className: 'calendar-header' },
          createElement('button', { onClick: prevMonth, className: 'month-nav' }, '←'),
          createElement('span', { className: 'current-month' }, formatMonth(currentMonth)),
          createElement('button', { onClick: nextMonth, className: 'month-nav' }, '→')
        ),
        createElement(
          'div',
          { className: 'weekdays' },
          weekDays.map((day) => createElement('div', { className: 'weekday', key: day }, day))
        ),
        createElement(
          'div',
          { className: 'calendar' },
          generateCalendarDays().map((item, index) =>
            createElement(
              'div',
              {
                className: `calendar-day
                           ${selectedDate?.toDateString() === item.date.toDateString() ? 'selected' : ''}
                           ${item.month !== 'current' ? 'other-month' : ''}
                           ${item.disabled ? 'disabled' : ''}`,
                onClick: () => !item.disabled ? handleDateSelection(item.date) : null,
                key: index,
              },
              item.day
            )
          )
        )
      );

  // Sección de tickets
  const ticketsSection = createElement(
    'div',
    null,
    createElement('div', { className: 'ticket-type' },
      createElement('span', null, t.adult),
      createElement('span', null, `$${(adultPrice / 100).toLocaleString('es-CL')}`),
      createElement('div', { className: 'quantity-control' },
        createElement('button', { 
          onClick: () => {
            const newAdultCount = adults - 1;
            if (newAdultCount === 0 && children === 0) return;
            setAdults(Math.max(0, newAdultCount));
          },
          disabled: adults === 0 || (adults === 1 && children === 0)
        }, '-'),
        createElement('span', null, adults),
        createElement('button', { onClick: () => setAdults(adults + 1) }, '+')
      )
    ),
    createElement('div', { className: 'ticket-type' },
      createElement('span', null, t.child),
      createElement('span', null, `$${(childPrice / 100).toLocaleString('es-CL')}`),
      createElement('div', { className: 'quantity-control' },
        createElement('button', { 
          onClick: () => {
            const newChildCount = children - 1;
            if (newChildCount === 0 && adults === 0) return;
            setChildren(Math.max(0, newChildCount));
          },
          disabled: children === 0 || (children === 1 && adults === 0)
        }, '-'),
        createElement('span', null, children),
        createElement('button', { onClick: () => setChildren(children + 1) }, '+')
      )
    ),
    createElement('div', { className: 'total-price ticket-type' }, [
      createElement('span', { className: 'total-label' }, `${t.total}:`),
      createElement('span', { className: 'price-amount' }, ` $${((adults * adultPrice + children * childPrice) / 100).toLocaleString('es-CL')}`)
    ])
  );

  // Sección de Ritual Patagónico - ahora con selección individual por adulto
  const ritualTimeSlots = generateRitualTimeSlots();
  
  const ritualSection = createElement(
    'div',
    { className: 'ritual-section' },
    // Descripción y precio con descuento.
    // Solo se muestra DESPUÉS de elegir fecha, porque el precio (y el % de
    // descuento) dependen de la temporada de la fecha seleccionada.
    selectedDate ? createElement('div', { className: 'ritual-header-info' },
      createElement('p', { className: 'ritual-description' }, t.ritualDescription.replace('{discount}', ritualDiscountPercent)),
      createElement('div', { className: 'ritual-price-wrapper' },
        ritualDiscountPercent > 0 && createElement('span', { className: 'ritual-original-price' },
          `$${(ritualOriginalPrice / 100).toLocaleString('es-CL')}`
        ),
        createElement('span', { className: 'ritual-price-tag' },
          `$${(ritualUnitPrice / 100).toLocaleString('es-CL')} ${t.perPerson}`
        )
      )
    ) : null,
    
    loadingRitual 
      ? createElement('div', { className: 'ritual-loading' }, t.checking)
      : createElement(
          'div',
          { className: 'adult-rituals-list' },
          // Crear una fila para cada adulto
          adultRituals.map((ritual, adultIndex) =>
            createElement(
              'div',
              { className: 'adult-ritual-row', key: adultIndex },
              // Información del adulto y toggle
              createElement('div', { className: 'adult-ritual-header' },
                createElement('label', { className: 'adult-ritual-label' },
                  createElement('input', {
                    type: 'checkbox',
                    checked: ritual.enabled,
                    onChange: () => handleRitualToggle(adultIndex),
                    className: 'ritual-checkbox'
                  }),
                  createElement('span', { className: 'adult-ritual-name' }, 
                    `${t.adultShort} ${adultIndex + 1} ${t.adultDescription}`
                  )
                ),
                ritual.enabled && ritual.time && createElement('span', { className: 'adult-ritual-time-badge' },
                  `${ritual.time} ${t.hours}`
                )
              ),
              
              // Selector de horario (solo si está habilitado)
              // Si no hay horarios disponibles para la hora de entrada elegida,
              // mostrar un mensaje en vez de un selector vacío.
              ritual.enabled && ritualTimeSlots.length === 0 && createElement(
                'div',
                { className: 'ritual-no-slots' },
                t.noRitualSlots
              ),

              ritual.enabled && ritualTimeSlots.length > 0 && createElement(
                'div',
                { className: 'adult-ritual-times' },
                ritualTimeSlots.map((time) => {
                  const availableSlots = getAvailableForTime(time, adultIndex);
                  const isSoldOut = availableSlots <= 0;
                  const isSelected = ritual.time === time;
                  
                  return createElement(
                    'button',
                    {
                      className: `adult-ritual-time-btn ${isSelected ? 'selected' : ''} ${isSoldOut ? 'disabled' : ''}`,
                      onClick: () => !isSoldOut && handleRitualTimeSelection(adultIndex, time),
                      disabled: isSoldOut,
                      key: time,
                    },
                    createElement('span', { className: 'time-value' }, time),
                    // Si está agotado, mostrar "Agotado"
                    isSoldOut && createElement('span', { className: 'availability-badge sold-out' }, t.soldOut),
                    // Si está seleccionado y hay disponibilidad, mostrar cuántos quedan
                    isSelected && !isSoldOut && createElement('span', { className: 'availability-badge' }, 
                      `${availableSlots} ${t.available}`
                    )
                  );
                })
              )
            )
          )
        ),
    
    // Resumen del ritual con precio original y descuento
    enabledRitualsCount > 0 && createElement(
      'div',
      { className: 'ritual-summary' },
      createElement('span', { className: 'ritual-summary-label' }, `${enabledRitualsCount} x ${t.ritual}`),
      createElement('div', { className: 'ritual-summary-prices' },
        ritualDiscountPercent > 0 && createElement('span', { className: 'ritual-summary-original' },
          `$${((enabledRitualsCount * ritualOriginalPrice) / 100).toLocaleString('es-CL')}`
        ),
        createElement('span', { className: 'ritual-summary-discounted' }, 
          `$${(calculateRitualTotal() / 100).toLocaleString('es-CL')}`
        )
      )
    )
  );

  // Generar resumen del ritual para el header
  const getRitualSummary = () => {
    if (enabledRitualsCount === 0) return null;
    
    const times = adultRituals
      .filter(r => r.enabled && r.time)
      .map(r => r.time);
    
    const uniqueTimes = [...new Set(times)];
    
    if (uniqueTimes.length === 1) {
      return `${enabledRitualsCount}x ${uniqueTimes[0]} ${t.hours}`;
    } else {
      return `${enabledRitualsCount} ${t.ritual.toLowerCase()}`;
    }
  };

  // Total general incluyendo ritual
  const totalSection = createElement(
    'div',
    { className: 'grand-total' },
    createElement('span', { className: 'total-label' }, `${t.total}:`),
    createElement('span', { className: 'total-amount' }, `$${(calculateTotal() / 100).toLocaleString('es-CL')}`)
  );

  return createElement(
    'div',
    { className: 'booking-container' },
    sections.map((section) =>
      createElement(
        'div',
        {
          className: `accordion-section ${isSectionVisible(section) ? 'visible' : ''} ${openSections.includes(section) ? 'active' : ''}`,
          key: section,
        },
        createElement(
          'div',
          { className: 'accordion-header', onClick: () => toggleSection(section) },
          createElement('h2', null,
            section === 'time' ? t.hour :
            section === 'date' ? t.date :
            section === 'ritual' ? t.ritualOptional :
            t.tickets),
          selectedTime && section === 'time' ? createElement('span', { className: 'selection-summary' }, `${selectedTime} ${t.hours}`) : null,
          selectedDate && section === 'date' ? createElement('span', { className: 'selection-summary' }, formatDate(selectedDate)) : null,
          (adults > 0 || children > 0) && section === 'tickets' ? createElement('span', { className: 'selection-summary' },
            `${adults} ${adults === 1 ? t.adult_singular : t.adult_plural}, ${children} ${children === 1 ? t.child_singular : t.child_plural}`
          ) : null,
          section === 'ritual' && enabledRitualsCount > 0 ? createElement('span', { className: 'selection-summary' }, 
            getRitualSummary()
          ) : null
        ),
        createElement(
          'div',
          { className: 'accordion-content' },
          section === 'time' ? timeSection : 
          section === 'date' ? dateSection : 
          section === 'ritual' ? ritualSection :
          ticketsSection
        )
      )
    ),
    totalSection,
    createElement('button', { 
      className: `add-to-cart-button ${isAddingToCart ? 'loading' : ''}`, 
      onClick: addToCart, 
      disabled: isAddingToCart || !selectedTime || !selectedDate || (adults === 0 && children === 0) || adultRituals.some(r => r.enabled && !r.time)
    }, isAddingToCart ? t.addingToCart : t.addToCart)
  );
};

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('booking-component');
  if (container) {
    render(createElement(BookingComponent), container);
  }
});

